import React, { useEffect, useState } from 'react';

import { register } from '../i18n';

import '../css/LandscapeOrientationPrompt.less';

const t = register('LandscapeOrientationPrompt');

function isMobileDevice() {
  if (navigator.userAgentData?.mobile) {
    return true;
  }

  const ua = navigator.userAgent || '';

  // iPadOS 13+ may report as MacIntel
  if (/iPad/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
    return true;
  }

  return /iPhone|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua);
}

function isPortrait() {
  return window.matchMedia('(orientation: portrait)').matches
    || window.innerHeight > window.innerWidth;
}

function shouldShowPrompt() {
  return isMobileDevice() && isPortrait();
}

export default function LandscapeOrientationPrompt() {
  const [visible, setVisible] = useState(shouldShowPrompt);

  useEffect(() => {
    const update = () => setVisible(shouldShowPrompt());
    window.addEventListener('orientationchange', update);
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('orientationchange', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <div
      aria-labelledby='landscape-orientation-prompt-title'
      aria-live='polite'
      className='landscape-orientation-prompt'
      role='alertdialog'>
      <div className='landscape-orientation-prompt__content'>
        <h2 id='landscape-orientation-prompt-title'>
          {t('title', 'Rotate Your Device')}
        </h2>
        <p>
          {t('message', 'Please rotate your device to landscape mode for the best experience.')}
        </p>
      </div>
    </div>
  );
}
